'use strict';

import React, { Component, Fragment } from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextEditor from 'Components/Forms/Elements/TextEditor';
import TextInput from 'Components/Forms/Elements/TextInput';
import FileInput from 'Components/Forms/Elements/FileInput';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import Switch from 'Components/Forms/Elements/Switch';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import TestSaferPayPaymentKit from 'Components/Back/TestSaferPayPaymentKit';
import TestPlanetPaymentKit from 'Components/Back/TestPlanetPaymentKit';
import TestStripePaymentKit from 'Components/Back/TestStripePaymentKit';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import { isTrue } from 'Shared/utilities';
import { etablishment_equipments as service_options } from 'Shared/options';
import { action, URL } from 'Shared/Routes';
const app = window.app;
const qwest = window.qwest;
const kits = ['saferpay', 'planet', 'stripe'];
function getIdFromPath() {
  let pathname = document.location.pathname;
  if (pathname.endsWith('/') && pathname !== '/') {
    pathname = pathname.slice(0, -1);
  }
  return pathname.slice(pathname.lastIndexOf('/') + 1);
}
export default class EtablishmentForm extends Component {
  state = {
    status_messages: {},
    id: this.props.id || getIdFromPath(),
    'etablishment[service]': [],
    'etablishment[status]': true,
    safer_pay_ok: [],
    current_tab: 0
  };
  handleChange = handleChange.bind(this);
  handleFileChange = handleFileChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchEtablishment();
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const newly_enabled_kit = kits.find(function (kit) {
      const pattern = 'etablishment[payment_kits][' + kit + ']';
      if (!state[pattern]) return false;
      return state[pattern] !== prev_state[pattern];
    });
    if (newly_enabled_kit) {
      const update = {};
      kits.filter(kit => kit !== newly_enabled_kit).forEach(function (kit) {
        update['etablishment[payment_kits][' + kit + ']'] = false;
      });
      component.setState(update);
    }
  }
  fetchEtablishment = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getEtablishment'), {
      id: props.id || getIdFromPath()
    }).then(function (xhr, response) {
      let {
        images,
        service,
        front_page_order,
        latitude,
        longitude,
        wl_logo,
        wl_background,
        ...etablishment
      } = response.data || {};
      ['latitude', 'longitude', 'geometry'].forEach(field => delete etablishment[field]);
      images = (images || []).map(function (image) {
        const state_img = {
          ...image,
          status: 'uploaded'
        };
        delete state_img.upload_date;
        return state_img;
      });
      wl_logo = (wl_logo || []).map(function (image) {
        const state_img = {
          ...image,
          status: 'uploaded'
        };
        delete state_img.upload_date;
        return state_img;
      });
      wl_background = (wl_background || []).map(function (image) {
        const state_img = {
          ...image,
          status: 'uploaded'
        };
        delete state_img.upload_date;
        return state_img;
      });
      const update = getStateFromObject({
        data: etablishment,
        model: 'etablishment'
      });
      update.safer_pay_ok = response.safer_pay_ok || [];
      update.safer_pay_ok.forEach(function (field) {
        if (field === 'saferpay_user') {
          update['etablishment[saferpay_ukey]'] = '';
        } else {
          update['etablishment[' + field + ']'] = '';
        }
      });
      component.setState({
        ...update,
        'etablishment[front_page_order]': String(front_page_order || ''),
        'etablishment[images]': images,
        '__files-etablishment[images]': images,
        'etablishment[wl_logo]': wl_logo,
        '__files-etablishment[wl_logo]': wl_logo,
        'etablishment[wl_background]': wl_background,
        '__files-etablishment[wl_background]': wl_background,
        'etablishment[service]': service,
        loading: false
      });
      if (app.state.session.user?.roles?.includes?.('admin')) {
        component.fetchUser();
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllUsers'), {
      etablishment: props.id || getIdFromPath(),
      with_count: false
    }).then(function (xhr, response) {
      let {
        roles,
        ...user
      } = response.data[0] || {};
      const update = getStateFromObject({
        data: user,
        model: 'user'
      });
      component.setState({
        ...update,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  create = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const state_data = {
      ...state
    };
    if (state['etablishment[saferpay_ukey]']) {
      state_data['etablishment[saferpay_user]'] = state['etablishment[saferpay_ukey]'];
    }
    delete state_data['etablishment[saferpay_ukey]'];
    const etablishment = getFormData({
      state: state_data,
      pattern: 'etablishment['
    });
    const user = getFormData({
      state: state_data,
      pattern: 'user['
    });
    Array.from(user.keys()).reduce((props, prop) => props.includes(prop) ? props : props.concat(prop), []).forEach(function (prop) {
      etablishment.append(prop, user.get(prop));
    });
    qwest.post('/etablishment/create', etablishment).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo('/liste-des-etablissements');
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  update = async e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    const is__admin = app.state.session.user?.roles?.includes('admin');
    const etablishment_id = state['etablishment[id]'];
    const state_data = {
      ...state
    };
    delete state_data['etablishment[id]'];
    if (state['etablishment[saferpay_ukey]']) {
      state_data['etablishment[saferpay_user]'] = state['etablishment[saferpay_ukey]'];
    }
    ['etablishment[saferpay_ukey]', 'etablishment[created_at]', 'etablishment[updated_at]', 'etablishment[slug]'].forEach(field => delete state_data[field]);
    if (!is__admin) {
      ['etablishment[address][hotel_name]', 'etablishment[address][line_1]', 'etablishment[address][line_2]', 'etablishment[address][postal_code]', 'etablishment[address][city]', 'etablishment[phone_number]', 'etablishment[email]', 'etablishment[stripe_sk]', 'etablishment[front_page]', 'etablishment[front_page_order]', 'etablishment[address][slug]', 'etablishment[id_property]', 'etablishment[name]', 'etablishment[has_payment]', 'etablishment[status]'].forEach(field => delete state_data[field]);
      Object.keys(state_data).forEach(function (field) {
        if (field.includes('[payment_kits]')) {
          delete state_data[field];
        }
      });
    }
    if (Array.isArray(state_data['etablishment[images]'])) {
      state_data['etablishment[images]'].forEach(function (img) {
        delete img.variants;
      });
    } else {
      Object.keys(state_data).forEach(function (field) {
        if (field.includes('[variants]')) {
          delete state_data[field];
        }
      });
    }
    state_data['etablishment[id]'] = etablishment_id;
    const etablishment = getFormData({
      state: state_data,
      pattern: 'etablishment['
    });
    const user = getFormData({
      state: state_data,
      pattern: 'user['
    });
    const roles = props.roles || [];
    try {
      var response = await ajaxRequest(action('UpdateEtablishment'), {
        data: etablishment,
        files: true
      });
    } catch (e) {
      return component.setState(e);
    }
    component.setState({
      loading: false,
      info: response.info,
      status_messages: {}
    });
    if (roles.includes('admin')) {
      component.setState({
        loading: true
      });
      delete user.roles;
      try {
        var user_response = await ajaxRequest(action('UpdateUser'), {
          data: user
        });
      } catch (e) {
        return component.setState(e);
      }
      if (app.state.session?.user?.id === user_response.updated_id) {
        Object.assign(app.state.session.user, user_response.update || {});
      }
      component.setState({
        loading: false,
        info: response.info || user_response.info,
        status_messages: {}
      });
      component.fetchEtablishment();
    } else {
      component.fetchEtablishment();
    }
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'etablishment[phone_number]'
    });
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleServiceChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["etablishment[service]"];
    let service = state["etablishment[service]"].slice(0);
    if (service.includes(name)) {
      service = service.filter(service => service !== name);
      component.setState({
        "etablishment[service]": service,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["etablishment[service]"];
      service.push(name);
      component.setState({
        "etablishment[service]": service,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  preventSubmit = e => e?.preventDefault?.();
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const roles = props.roles || [];
    const is__admin = roles.includes('admin');
    const session_etablishment_id = app.state.session?.user?._etablishment?.id;
    const is__super_admin = is__admin && state.id === session_etablishment_id;
    const isHotelier = is__admin ? false : true;
    const images = (state["etablishment[images]"] || []).map(function (image) {
      let output = /*#__PURE__*/React.createElement(Image, {
        src: image.url,
        key: image.url,
        className: "back-image back-image--form u-margin-5"
      });
      return output;
    });
    let services = (service_options || []).map(function (service) {
      let output = /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4,
        key: service.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleServiceChange,
        label: service.label || service.value,
        name: service.value,
        value: state['etablishment[service]'].includes(service.value),
        status: state.status_messages
      }));
      return output;
    });
    const has__payment = isTrue(state['etablishment[has_payment]']);
    const is__disabled = !isTrue(state['etablishment[status]']);
    const admin_only_fields = is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Champs administrateur"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3,
      className: "u-flex u-flex-column u-content-end"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: !is__disabled,
      name: "etablishment[status]",
      "top-label": "Actif",
      label: "Oui",
      "left-label": "Non",
      className: "u-margin-top-10",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3,
      className: "u-flex u-flex-column u-content-end"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['etablishment[has_payment]'],
      name: "etablishment[has_payment]",
      "top-label": "Kit de paiement",
      label: "Oui",
      "left-label": "Non",
      className: "u-margin-top-10",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3,
      className: "u-flex u-flex-column u-content-end"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['etablishment[front_page]'],
      name: "etablishment[front_page]",
      "top-label": "Mise en avant (Accueil)",
      label: "Oui",
      "left-label": "Non",
      className: "u-margin-top-10",
      "read-only": is__disabled,
      status: state.status_messages
    })))) : undefined;
    const saferpay_enabled = has__payment && isTrue(state['etablishment[payment_kits][saferpay]']);
    const planet_enabled = has__payment && isTrue(state['etablishment[payment_kits][planet]']);
    const stripe_enabled = has__payment && isTrue(state['etablishment[payment_kits][stripe]']);
    const payment_kits = has__payment && is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Kits de paiement"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['etablishment[payment_kits][saferpay]'],
      name: "etablishment[payment_kits][saferpay]",
      "top-label": "Saferpay",
      label: "Activ\xE9",
      "left-label": "D\xE9sactiv\xE9",
      className: "u-margin-top-10",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['etablishment[payment_kits][planet]'],
      name: "etablishment[payment_kits][planet]",
      "top-label": "Planet",
      label: "Activ\xE9",
      "left-label": "D\xE9sactiv\xE9",
      className: "u-margin-top-10",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['etablishment[payment_kits][stripe]'],
      name: "etablishment[payment_kits][stripe]",
      "top-label": "Stripe",
      label: "Activ\xE9",
      "left-label": "D\xE9sactiv\xE9",
      className: "u-margin-top-10",
      status: state.status_messages
    })))) : undefined;
    const saferpay_area = saferpay_enabled && is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-bottom-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Saferpay"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[saferpay_customer_id]'],
      name: "etablishment[saferpay_customer_id]",
      label: "Num\xE9ro de client API",
      status: state.status_messages,
      autoComplete: "false"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[saferpay_fields_token]'],
      name: "etablishment[saferpay_fields_token]",
      label: "Token d'acc\xE8s Saferpay Fields",
      status: state.status_messages,
      autoComplete: "false"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[saferpay_terminal]'],
      name: "etablishment[saferpay_terminal]",
      label: "Terminal ID",
      status: state.status_messages,
      helper_txt: state['etablishment[saferpay_terminal]'] ? undefined : state.safer_pay_ok.includes('saferpay_terminal') ? 'Caché, inchangé si laissé vide' : 'Non renseigné',
      className: state['etablishment[saferpay_terminal]'] ? 'mui-textinput-bold-helper' : 'mui-alt-textinput-color',
      autoComplete: "false"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[saferpay_ukey]'],
      name: "etablishment[saferpay_ukey]",
      label: "Utilisateur (JSON Authentification basique)",
      status: state.status_messages,
      helper_txt: state['etablishment[saferpay_ukey]'] ? undefined : state.safer_pay_ok.includes('saferpay_user') ? 'Caché, inchangé si laissé vide' : 'Non renseigné',
      className: state['etablishment[saferpay_ukey]'] ? 'mui-textinput-bold-helper' : 'mui-alt-textinput-color',
      autoComplete: "false"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[saferpay_key]'],
      name: "etablishment[saferpay_key]",
      label: "Mot de passe (JSON Authentification basique)",
      status: state.status_messages,
      helper_txt: state['etablishment[saferpay_key]'] ? undefined : state.safer_pay_ok.includes('saferpay_key') ? 'Caché, inchangé si laissé vide' : 'Non renseigné',
      className: state['etablishment[saferpay_key]'] ? 'mui-textinput-bold-helper' : 'mui-alt-textinput-color',
      autoComplete: "false"
    })))) : undefined;
    const planet_area = planet_enabled && is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-bottom-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Planet"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[planet_merchant_id]'],
      name: "etablishment[planet_merchant_id]",
      label: "Identifiant marchant (entityId)",
      status: state.status_messages,
      helper_txt: "Par d\xE9faut utilis\xE9 si non rempli"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[planet_api_secret]'],
      name: "etablishment[planet_api_secret]",
      label: "Code secret (validation_code)",
      status: state.status_messages,
      helper_txt: "Par d\xE9faut utilis\xE9 si non rempli"
    })))) : undefined;
    const stripe_area = stripe_enabled && is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-bottom-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Stripe"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[stripe_pk]'],
      name: "etablishment[stripe_pk]",
      label: "Cl\xE9 publique",
      status: state.status_messages,
      helper_txt: "Commence par pk_"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[stripe_sk]'],
      name: "etablishment[stripe_sk]",
      label: "Cl\xE9 secr\xE8te",
      status: state.status_messages,
      helper_txt: "Commence par sk_ ou rk_",
      type: "password"
    })))) : undefined;
    const white_label_fields = isHotelier === true || is__super_admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-section u-margin-top-40 u-margin-bottom-20"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-form-section__title"
    }, "Lien de r\xE9servation"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-0 u-margin-bottom-0"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif,.svg",
      onChange: component.handleFileChange,
      name: "etablishment[wl_logo]",
      data: state,
      multiple: false,
      status: state.status_messages,
      label: "Logo de votre \xE9tablissement"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif,.svg",
      onChange: component.handleFileChange,
      name: "etablishment[wl_background]",
      data: state,
      multiple: false,
      status: state.status_messages,
      label: "Image de fond"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[wl_website_url]'],
      name: "etablishment[wl_website_url]",
      label: "Adresse de votre site web",
      helper_txt: "Optionnel, affich\xE9 lors de la r\xE9servation",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, state['etablishment[slug]'] ? /*#__PURE__*/React.createElement("a", {
      href: URL('FrontDirectBookingPage').replace(':slug', state['etablishment[slug]']),
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Lien vers la r\xE9servation directe") : undefined))) : undefined;
    const etablishment_infos = is__admin && !is__super_admin ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement("h4", {
      className: "back-title"
    }, "Galerie d'images"), /*#__PURE__*/React.createElement("div", {
      className: "etablishment-image"
    }, images)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement("h4", {
      className: "back-title"
    }, "Description"), state['etablishment[description]'] ? /*#__PURE__*/React.createElement("div", {
      className: "etablishment-description",
      dangerouslySetInnerHTML: {
        __html: state["etablishment[description]"]
      }
    }) : 'Aucune description renseignée.'))) : undefined;
    const services_n_medias = isHotelier || is__super_admin ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width"
    }, "Services additionnels propos\xE9s par l'\xE9tablissement"), services, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      className: services.length > 0 ? ' u-margin-top-10' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextEditor, {
      onChange: component.handleChange,
      value: state["etablishment[description]"] || '',
      name: "etablishment[description]",
      label: "Description",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "etablishment[images]",
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Photo(s)"
    })))) : undefined;
    const test_payment = props.type !== 'update' ? undefined : is__admin && has__payment && saferpay_enabled ? /*#__PURE__*/React.createElement(TestSaferPayPaymentKit, {
      etablishment: state['etablishment[id]'],
      API_TOKEN: state['etablishment[saferpay_fields_token]'],
      API_CUSTOMER_ID: state['etablishment[saferpay_customer_id]']
    }) : is__admin && has__payment && planet_enabled ? /*#__PURE__*/React.createElement(TestPlanetPaymentKit, {
      id: state['etablishment[id]']
    }) : is__admin && has__payment && stripe_enabled ? /*#__PURE__*/React.createElement(TestStripePaymentKit, {
      id: state['etablishment[id]'],
      pk: state['etablishment[stripe_pk]'],
      sk: state['etablishment[stripe_sk]']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      onSubmit: component.preventSubmit,
      method: "POST",
      action: action('UpdateEtablishment'),
      autoComplete: "off"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement("h2", {
      className: "back-title"
    }, "Etablissement"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[id_property]'],
      name: "etablishment[id_property]",
      "read-only": isHotelier,
      type: "text",
      label: "Id property",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[name]'],
      name: "etablishment[name]",
      type: "text",
      label: "Nom myWO",
      "read-only": isHotelier,
      status: state.status_messages,
      autoComplete: "false"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[address][hotel_name]'],
      name: "etablishment[address][hotel_name]",
      label: "Nom de l'h\xF4tel",
      "read-only": isHotelier,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[address][line_1]'],
      name: "etablishment[address][line_1]",
      label: "Adresse",
      "read-only": isHotelier,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[address][line_2]'],
      name: "etablishment[address][line_2]",
      label: "Compl\xE9ment d'adresse",
      "read-only": isHotelier,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[address][postal_code]'],
      name: "etablishment[address][postal_code]",
      label: "Code postal",
      "read-only": isHotelier,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[address][city]'],
      name: "etablishment[address][city]",
      label: "Ville",
      "read-only": isHotelier,
      status: state.status_messages
    })), isHotelier === true ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[phone_number]'],
      name: "etablishment[phone_number]",
      label: "Num\xE9ro de t\xE9l\xE9phone",
      "read-only": true,
      status: state.status_messages
    })) : /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      value: state['etablishment[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[email]'],
      name: "etablishment[email]",
      label: "Adresse mail",
      "read-only": isHotelier,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[cc_email]'],
      name: "etablishment[cc_email]",
      label: "Adresse mail en copie des r\xE9servations",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['etablishment[google_link]'],
      name: "etablishment[google_link]",
      type: "text",
      label: "Lien avis Google",
      status: state.status_messages
    })), admin_only_fields, payment_kits, saferpay_area, planet_area, stripe_area, test_payment, etablishment_infos, services_n_medias), white_label_fields), is__admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-margin-top-10"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement("h2", {
      className: "back-title"
    }, "Utilisateur"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      name: "user[login]",
      type: "text",
      label: "E-mail (login)",
      autoComplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[password]'],
      name: "user[password]",
      type: "password",
      label: "Mot de passe (minimum 12 caract\xE8res)",
      autoComplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      autoComplete: "new-lastname",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      autoComplete: "new-firstname",
      status: state.status_messages
    })))) : undefined, status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: props.type === 'update' ? component.update : component.create
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cet établissement', loader)));
    return output;
  }
}
